import { innerHTML } from 'diffhtml';
import { emitter } from './../utils/custom-events.js';
import notifications from './../notifications.js';
import { sessionKey, lastProduct, setNavigationCookies } from './../store/cookies.js';
import { open } from './../libs/tabs.js';
import emptyGameTemplate from './../templates/games/games-grid-empty.handlebars';
import { loveGame, unLoveGame, setRecentGames } from './../services/rest.js';
import { throwError } from './../services/api.js';
import { store } from './store.js';
import { gamesSelector } from './selectors.js'

const TIMEOUT = 500;
// timeout for effects
emitter.on('tabbed', styleGameItemHeart);

function toggleClass(element, classNameToToggle) {
	element.classList.toggle(classNameToToggle);
}

function toggleClassWithTimeout(element, classNameToToggle, timeout = TIMEOUT) {
	window.setTimeout(
		() => {
			toggleClass(element, classNameToToggle);
		},
		500
	);
}

function applyClickEffect(element) {
	const effectClass = 'click-effect';
	toggleClass(element, effectClass);
	toggleClassWithTimeout(element, effectClass);
}

function renderUpdatedLoveCount(gamecode) {
	const {all} = store.get().gameResource.gameData;
	const game = all.find(game => game.code === gamecode);

	const instances = document.querySelectorAll(
		`.game-item[data-gamecode="${gamecode}"] .game-item__love`
	);
	for (const instance of instances) {
		if (game.loved && sessionKey()) {
			instance.classList.add('game-item__love--selected');
		} else {
			instance.classList.remove('game-item__love--selected');
		}
		const rating = instance.querySelector('.game-item__love-counter');
		rating.textContent = game.likes || 0;
	}
}

/* This runs in O(m*n)
 */
function styleGameItemHeart() {
	const storeAllGames = store.get().gameResource.gameData.all;
	// 1. n iterations to get m games
	const games = storeAllGames.filter(game => game.loved);
	if (games && games.length > 0) {
		// 2.1. m iterations to...
		games.forEach(game => {
			// 2.2 ... run n iterations
			renderUpdatedLoveCount(game.gamecode);
		});
	}
}

function handleLoveEvents({target}) {
	if (target.classList.contains('game-item__love')) {
		if (sessionKey()) {
			//target.classList.toggle('game-item__love--selected');
			applyClickEffect(target);
			const {gamecode} = target.closest('.game-item').dataset;
			const game = store.get().gameResource.gameData.all.find(game => game.code === gamecode);
			const loved = !game.loved;
			loved ? loveGame({string: gamecode}): unLoveGame({string: gamecode});
			const likes = loved ? (parseInt(game.likes, 10) || 0) + 1 : (parseInt(game.likes, 10) || 0) - 1 ;
			game.set({loved, likes});
			renderUpdatedLoveCount(gamecode);
			// target.classList.toggle('game-item__love--selected');
			return false;
		} else {
			const $pusher = document.getElementsByClassName('pusher')[0];
			const text = $pusher.dataset.lovegamesLogout;
			notifications.showNotification(text, 'green', true);
			return false;
		}
	}
}

async function setRecentlyPlayedGame(gamecode) {
	const recentGame = await setRecentGames({string: gamecode});
	return recentGame;
}

function markup() {
	const filteredGames = gamesSelector(store.get());

	const {dataset: { titleEmpty, messageEmpty, titleAuth, messageAuth }, value} = document.querySelector('#section3 .filters input[type="radio"]:checked');
	if(sessionKey()){
		if(filteredGames.length > 0){
			const templateContext = {
				...store.get().gameResource,
				...{
					gameData: {
						all: filteredGames,
					}
				}
			};
			return store.get().templates.games(templateContext);
		}
		return emptyGameTemplate({title: titleEmpty, message: messageEmpty, [value]: value});
	}
	return emptyGameTemplate({title: titleAuth, message: messageAuth, [value]: value});
}

function render() {
	if(document.getElementById('section3') && !document.getElementById('section3').getAttribute('aria-hidden')){
		const grid = document.querySelector('#section3 .game-grid');
		innerHTML(grid, markup());
		styleGameItemHeart();

		window.lazySizes.loader.checkElems();
	}
}

emitter.on('logout', render);
store.on('update', (currentState, prevState) => {
	if(currentState !== prevState){
		render();
	}
});

function init() {
	render();
	open('section3');
}

export {init, handleLoveEvents, setRecentlyPlayedGame};



// WEBPACK FOOTER //
// ./mobile-core/src/casino/mygames.js